import { Injectable, inject } from "@angular/core";
import { HttpRequestService } from "../../../../../shared/services/http-request/http-request.service";
import { API } from "../../../../../shared/constants/api-url";
import { Observable } from "rxjs";
import { IPermission } from "./models/permission.model";
import { KeycloakGroup } from "./models/keycloak-group.model";
import { HelperService } from "../../../../../shared/services/common/helper.service";

@Injectable({
    providedIn: 'root'
})
export class RolePermissionService {
    private httpRequestService = inject(HttpRequestService);
    private helperService = inject(HelperService);


    getPermissionById(id: string): Observable<unknown> {
        return this.httpRequestService.get(`${API.COMMON.PERMISSIONS}/${id}`);
    }

    updatePermission(permission: IPermission): Observable<unknown> {
        return this.httpRequestService.put(API.COMMON.PERMISSIONS, permission);
    }

    createPermission(permission: IPermission): Observable<unknown> {
        return this.httpRequestService.post(API.COMMON.PERMISSIONS, permission);
    }

    isServerPermission(roleName: string): boolean {
        return ['uma_protection'].includes(roleName);
    }

    getGroupById(id: string, skipLoader: boolean = false): Observable<unknown> {
        return this.httpRequestService.get(`${API.COMMON.ROLES}/${id}`, null, null, skipLoader && this.helperService.getSkipLoaderContext());
    }

    createGroup(group: KeycloakGroup): Observable<unknown> {
        return this.httpRequestService.post(API.COMMON.ROLES, group);
    }

    updateGroup(id: string, group: KeycloakGroup): Observable<unknown> {
        return this.httpRequestService.put(`${API.COMMON.ROLES}/${id}`, group);
    }

    getAllRoles(payload?): Observable<unknown> {
        return this.httpRequestService.post(`${API.COMMON.ROLES}list`, payload);
    }

    getAllPremissions(): Observable<unknown> {
        return this.httpRequestService.get(API.COMMON.PERMISSIONS);
    }

}